import { HttpService, ConfigService }               from '..';

/**
 * The service that initialize singleton connectors to IFaq and Bot servers.
 */
export class ServerConnector {

    // the singleton instance of this service
    private static iFaqHttpService: HttpService;

    // the singleton instance of this service
    private static botHttpService: HttpService;

    // the singleton instance of this service
    private static mediaHttpService: HttpService;

    /**
     * Get a singleton instance of this service. The HTTP basic configuration should be
     * the same for all application requests.
     */
    public static getIFaqServerConnectorInstance() {
        if (!ServerConnector.iFaqHttpService) {
            ServerConnector.iFaqHttpService = new HttpService(
                ConfigService.getIntelligentFaqRootURL(), 
                ConfigService.getDefaulRequestTimeout());
        }
        return ServerConnector.iFaqHttpService;
    }

    /**
     * Get a singleton instance of BotServer connector. The HTTP basic configuration should be
     * the same for all application requests.
     */
    public static getBotServerConnectorInstance() {

        const defaultHeaders = {
            'botKey': ConfigService.botKey,
            'Content-Type': 'application/json; charset=utf-8', 
        };

        if (!ServerConnector.botHttpService) {
            ServerConnector.botHttpService = new HttpService(
                ConfigService.getBotServerRootURI(), 
                ConfigService.getDefaulRequestTimeout(),
                defaultHeaders,
                true);
        }
        return ServerConnector.botHttpService;
    }

    /**
     * Get a singleton instance of generic connector to retrieve media files with basic HTTP requests.
     * @param mediaType - The media type to retrieve
     * @param resourceUrl - The resource URL to configure
     */
    public static getMediaConnectorInstance(mediaType: string, resourceUrl: string) {

        const defaultHeaders = {
            'Content-Type': `image/${mediaType}`, 
        };

        if (!ServerConnector.mediaHttpService) {
            ServerConnector.mediaHttpService = new HttpService(
                resourceUrl, 
                ConfigService.getMediaRequestTimeout(),
                defaultHeaders,
                true);
        }
        return ServerConnector.mediaHttpService;
    }
}
